/**
 * GENERATED by `pnpm assets:decorations` from
 * `assets-src/profile/side-decorations/*.png` — do not edit by hand.
 *
 * Per-decoration geometry the profile hero uses to seat a side decoration:
 * its aspect ratio, and how far its own gilt frame rail is inset from the
 * art's right / bottom edge (as a fraction of width / height). Foliage on the
 * art extends past the rail on purpose; the rail is what lines up with the
 * hero's brass frame.
 */
export interface SideDecorationMetrics {
  /** width / height of the shipped (trimmed) art. */
  readonly aspectRatio: number;
  /** Right edge → gilt rail, as a fraction of width. */
  readonly railInsetRight: number;
  /** Bottom edge → gilt rail, as a fraction of height. */
  readonly railInsetBottom: number;
}

export const SIDE_DECORATION_METRICS: Record<string, SideDecorationMetrics> = {
  "candles-and-tomes": {
    "aspectRatio": 0.4764,
    "railInsetRight": 0.1865,
    "railInsetBottom": 0.045
  }
};
